<template>
  <div class="WhatsappWidget suscripcion-widget d-none d-md-block">
    <a
      title="Whatsapp"
      :href="'https://api.whatsapp.com/send?phone=' + configData.general.companyWhatsappPhone + '&text=Estimados!%20Necesito%20informaci%C3%B3n.%20&source=&data='"
      target="_blank"
    >
      <img src="@/assets/widget-whastapp.png" class="img-whatsapp" />
    </a>
  </div>
</template>

<script>
import data from '@/staticData.json';

export default {
  name: 'WhatsappWidget',
  data() {
    return {
      configData: data,
    };
  },
};
</script>

<style lang="scss" src="./WhatsappWidget.scss"></style>
